import React, { useState } from "react";
import { toast } from "react-toastify";
import { decideMyGift, isOk, messageOf } from "../../../services/gift";

const formatDay = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : "");

// "Do you still want to give a gift?" for a paused gift (its recipient's
// reservation expired unpaid). `gift` carries the `decision` block from the
// My Gifts API; onAnswered receives the updated gift.
export default function GiftDecisionDue({ gift, onAnswered }) {
  const [busy, setBusy] = useState("");
  const [confirmNo, setConfirmNo] = useState(false);
  const decision = gift && gift.decision;
  if (!decision) return null;

  const answer = async (keep) => {
    setBusy(keep ? "yes" : "no");
    const res = await decideMyGift(gift.gift_id, keep);
    setBusy("");
    setConfirmNo(false);
    if (isOk(res)) {
      toast.success(messageOf(res, keep ? "Your gift is active again." : "Your gift has been closed."));
      if (onAnswered) onAnswered(res.data.data);
    } else {
      toast.error(messageOf(res, "We couldn't save your answer. Please try again."));
      if (res && res.data && res.data.data && res.data.data.gift_id && onAnswered) onAnswered(res.data.data);
    }
  };

  return (
    <section className="vsr-card vsr-pay-due vsr-decision-due" aria-label="Your answer needed">
      <div className="vsr-pay-due-main">
        <span className="vsr-pay-due-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <rect x="3" y="8" width="18" height="13" rx="2" />
            <path d="M12 8v13M3 12h18M12 8c-1.5-3-5-3.5-5-1.25S9.5 8 12 8zM12 8c1.5-3 5-3.5 5-1.25S14.5 8 12 8z" />
          </svg>
        </span>
        <div className="vsr-pay-due-body">
          <p className="vsr-pay-due-eyebrow">Your answer needed</p>
          <h2 className="vsr-pay-due-title">Do you still want to give this gift?</h2>
          <p className="vsr-pay-due-session">
            The session requested{decision.recipientEmail ? <> by <b>{decision.recipientEmail}</b></> : null}
            {decision.mediumName ? <> with <b>{decision.mediumName}</b></> : null}
            {decision.date ? ` on ${decision.date} at ${decision.time}` : ""} wasn't paid for in time, so the reservation expired.
          </p>
          <p className="vsr-muted">
            <b>Yes:</b> the Gift Code works again and we'll invite your recipient to choose a new time. <b>No:</b> the code stops
            working.
            {decision.closesAt ? ` If we don't hear from you by ${formatDay(decision.closesAt)}, the gift closes automatically.` : ""}
          </p>
        </div>
      </div>
      <div className="vsr-pay-due-side vsr-decision-actions">
        {!confirmNo ? (
          <>
            <button type="button" className="vsr-btn" disabled={Boolean(busy)} onClick={() => answer(true)}>
              {busy === "yes" ? "Saving…" : "Yes, keep my gift"}
            </button>
            <button type="button" className="vsr-btn vsr-btn-outline" disabled={Boolean(busy)} onClick={() => setConfirmNo(true)}>
              No, close it
            </button>
          </>
        ) : (
          <>
            <p className="vsr-decision-confirm">Close this gift? The Gift Code and link will stop working.</p>
            <button type="button" className="vsr-btn vsr-btn-danger" disabled={Boolean(busy)} onClick={() => answer(false)}>
              {busy === "no" ? "Closing…" : "Yes, close my gift"}
            </button>
            <button type="button" className="vsr-btn vsr-btn-outline" disabled={Boolean(busy)} onClick={() => setConfirmNo(false)}>
              Keep thinking
            </button>
          </>
        )}
      </div>
    </section>
  );
}
